import React, { useMemo } from 'react'

import { BlockComponent } from 'common/builder/components/chart/FlowChart/components/Block/types'
import { ContentContainer } from 'common/builder/components/chart/FlowChart/components/ContentContainer/ContentContainer'
import { convertToIconString } from 'common/builder/components/chart/FlowChart/lib/utils/convertToIconString'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import TextWithIcon from 'common/builder/components/chart/FlowChart/nodes/shared/TextWithIcon/TextWithIcon'
import { FlowChartPlaceholderBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartPlaceholderBlock'

export const PlacehodlerBlock: BlockComponent<FlowChartPlaceholderBlock> = ({
  block: {
    data: { text, icon: IconComponent },
  },
}) => {
  const iconString = useMemo(
    () =>
      IconComponent
        ? convertToIconString(IconComponent, {
            size: sharedStyles.IconSizes.MEDIUM_LARGE,
            color: sharedStyles.Colors.Tints.NEUTRAL[2],
          })
        : null,
    [IconComponent],
  )

  return (
    <ContentContainer isEmpty>
      <TextWithIcon icon={iconString} empty>
        {text}
      </TextWithIcon>
    </ContentContainer>
  )
}
